import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon } from 'lucide-react';
interface ProgressHeaderProps {
  step: number;
  total: number;
  onBack: () => void;
}
export function ProgressHeader({
  step,
  total,
  onBack
}: ProgressHeaderProps) {
  const percent = step / total * 100;
  return <header className="mb-7 space-y-3" data-id="element-46" data-mp="fmntzjlrsjjq">
      <div className="flex items-center gap-3" data-id="element-47" data-mp="fnp85wy31m5o">
        <button type="button" onClick={onBack} aria-label="Volver a la pregunta anterior" className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-lavender-200 bg-white/90 text-ink-soft transition-colors active:scale-95 hover:text-violet-600" data-id="element-48" data-mp="km0i07odnwnw">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-49" data-mp="yk78v3uwswe2" />
        </button>
        <p className="text-sm font-semibold text-ink-muted" data-id="element-50" data-mp="2vebqxf0sac2j">
          Paso {step} de {total}
        </p>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-lavender-100" role="progressbar" aria-valuemin={1} aria-valuemax={total} aria-valuenow={step} aria-label={`Paso ${step} de ${total}`} data-id="element-51" data-mp="30dofq5b7tt7r">
        <motion.div className="h-full rounded-full bg-violet-500" initial={false} animate={{
        width: `${percent}%`
      }} transition={{
        duration: 0.45,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-52" data-mp="386d5fjplobbg" />
      </div>
    </header>;
}